'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('authInterceptorSvc', authInterceptorSvc);

  authInterceptorSvc.$inject = ['$q', '$log', '$cookies', 'windowSvc'];

  /**
   * This service deals with authenticated calls to the API.
   * This will behave as an $http interceptor that will add an auth header to all the auth'ed API requests,
   * and if it receives an updated header back it will update the cookie containing the token.
   */
  function authInterceptorSvc($q, $log, $cookies, windowSvc) {

    // fetch the token from the cookie at the beginning
    var token = $cookies.get('token');

    return {
      isLoggedIn: isLoggedIn,
      request: addHeader,
      getReauthToken: getReauthToken,
      hasReauthCookie: hasReauthCookie,
      getPermissions: getPermissions,
      hasPermission: hasPermission,
      getSessionId: getSessionId,
      isWriteOnlyUser: isWriteOnlyUser,
      verifyTokenIssued: verifyTokenIssued,
      getExpiration: getExpiration,
      refreshTokenFromCookie: refreshTokenFromCookie
    };

    /**
     * @return True if the user has a token and the token is not expired
     */
    function isLoggedIn() {
      return hasTokenCookie() && !tokenExpired();
    }

    function refreshTokenFromCookie() {
      token = $cookies.get('token');
    }

    /**
     * Get the expiration of the current token
     * @param  {string} jwt (Optional) Web token to check for expiration
     * @return {Date}                  The time when the token will expire
     */
    function getExpiration(jwt) {
      jwt = jwt || token;
      if (!jwt) {
        return null;
      }
      try {
        // split the JWT into three chunks of base64 - decode the middle chunck, parse it as JSON
        // and extract the .exp value then multiply by 1000 to get MS. Make a date from it.
        return new Date(JSON.parse(atob(jwt.split('.')[1])).exp * 1000);
      } catch (e) {
        return null;
      }
    }
    /**
     * @param  {string} jwt (Optional) Web token to check for expiration
     * @return {boolean}               True if the token is expired
     */
    function tokenExpired(jwt) {
      return getExpiration(jwt) < new Date();
    }

    /**
     * Get user permissions from token passed in or from previously stored token
     * @param {string} jwt (Optional) web token to check
     * @return null if token doesn't exist
     *         else, return array of available permissions
     */
    function getSessionId(jwt) {
      jwt = jwt || token;
      if (!jwt) {
        return null;
      }

      try {
        var sessionId = JSON.parse(atob(jwt.split('.')[1])).sessionId;
        if (!tokenExpired(jwt) && sessionId) {
          return sessionId;
        }
      } catch (e) {
        return null;
      }
      return null;
    }

    /**
     * Get user permissions from token passed in or from previously stored token
     * @param {string} jwt (Optional) web token to check
     * @return null if token doesn't exist
     *         else, return array of available permissions
     */
    function getPermissions(jwt) {
      jwt = jwt || token;
      if (!jwt) {
        return [];
      }

      try {
        var perms = JSON.parse(atob(jwt.split('.')[1])).permissions;
        if (!tokenExpired(jwt) && angular.isArray(perms)) {
          return perms;
        }
      } catch (e) {
        return [];
      }
      return [];
    }

    function hasPermission(permissionName) {
      return getPermissions(null).includes(permissionName);
    }

    /**
     * @param  {string} issued  the JWT issue date to verify against the local time.
     * @return {boolean}               true if the issued time is within timeout range.
     */
    function verifyTokenIssued(issued) {
      var parsedIssueDate = new Date(parseInt(issued)),
          parsedUpperBound = new Date(new Date().getTime() + 600000),
          parsedLowerBound = new Date(new Date().getTime() - 600000);
      return parsedIssueDate <= parsedUpperBound && parsedIssueDate >= parsedLowerBound;
    }

    /**
     * Fetches the the Reauth token from the cookie
     */
    function getReauthToken() {
      return $cookies.get('reauth_token');
    }

    /**
     * @return {boolean} true if token cookie exists
     */
    function hasTokenCookie() {
      return !!token || !_.isEmpty($cookies.get('token'));
    }

    /**
     * @return {boolean} true if the reauth cookie exists
     */
    function hasReauthCookie() {
      return !_.isEmpty($cookies.get('reauth_token'));
    }

    /**
     * Add the header to a request config
     * @param {$http config} config The $http config object to add headers to
     */
    function addHeader(config) {
      if (!_.startsWith(config.url, '/apiproxy')) {
        // If it doesn't start with API, don't intercept
        return config;
      }
      config.url = config.url.replace('/apiproxy', windowSvc.getApiUrl());
      // this is actually the XHR credentials flag
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials
      if (config.withCredentials) {
        if (canAddCredentials(config)) {
          config.headers['x-session-token'] = $cookies.get('token') || token;
        } else {
          $log.debug('User not logged in for credentialed request', config);
          return $q.reject({
            data: { errorCode: 'NO_TOKEN' },
            status: 401,
            statusText: 'no token',
            config: config
          });
        }
      }
      return config;
    }

    /**
     * @return True if user is not logged in but has token giving write-only permission
     **/
    function isWriteOnlyUser() {
      return _.includes(getPermissions(), 'USERS_WRITE_ONLY') || _.includes(getPermissions(), 'PASSWORD_RESET');
    }

    function canAddCredentials(config) {
      if (isLoggedIn()) {
        return true;
      }
      if ((config.method === 'POST' || config.method === 'GET') && isWriteOnlyUser()) {
        return true;
      }
      return false;
    }
  }
})();